export default __webpack_public_path__ + "static/media/kit_labellisation_argent.f587d189.pdf";